<div class="wrapper">
    <div class="single-list-item-option" [class.selected]="selected">
        <ng-content></ng-content>
        <div><ng-content select="[hint]"></ng-content></div>
    </div>
</div>
